import { Pencil, Trash2 } from 'lucide-react';
import type { ContentListItemAction } from './ContentListItem';

export function editAction(onClick: () => void): ContentListItemAction {
  return {
    key: 'edit',
    label: 'Edit',
    icon: <Pencil size="16px" />,
    onClick,
  };
}

export function deleteAction(onClick: () => void): ContentListItemAction {
  return {
    key: 'delete',
    label: 'Delete',
    icon: <Trash2 size="16px" />,
    onClick,
    colorScheme: 'red',
  };
}
